import React from 'react';

export default function PrivacyPolicy() {
  return (
    <main className="relative overflow-hidden px-6 py-24">
      {/* Soft background */}
      <div className="absolute inset-0 -z-10">
        <div className="absolute inset-0 bg-[radial-gradient(circle_at_20%_20%,rgba(139,92,246,0.12),transparent_60%)]" />
        <div className="absolute inset-0 bg-[linear-gradient(to_right,rgba(139,92,246,0.06)_1px,transparent_1px),linear-gradient(to_bottom,rgba(139,92,246,0.06)_1px,transparent_1px)] bg-[size:72px_72px]" />
      </div>

      <div className="mx-auto max-w-4xl">
        {/* Header */}
        <header className="mb-16 text-center">
          <h1 className="text-4xl font-extrabold tracking-tight text-gray-900 sm:text-5xl dark:text-gray-100">
            Privacy Policy
          </h1>
          <p className="mt-4 text-base text-gray-600 dark:text-gray-300">
            Your privacy matters. This policy explains how Akwid Labs collects, uses, and protects
            your information.
          </p>
          <p className="mt-2 text-sm text-gray-500">Last updated: {new Date().getFullYear()}</p>
        </header>

        {/* Content */}
        <section className="space-y-12 leading-relaxed text-gray-700 dark:text-gray-300">
          <div>
            <h2 className="mb-3 text-xl font-semibold text-gray-900 dark:text-gray-100">
              1. Introduction
            </h2>
            <p>
              Akwid Labs (Pvt) Ltd values your trust. This Privacy Policy outlines how we handle
              personal information when you interact with our website, products, and services.
            </p>
          </div>

          <div>
            <h2 className="mb-3 text-xl font-semibold text-gray-900 dark:text-gray-100">
              2. Information We Collect
            </h2>
            <p className="mb-2">We may collect the following types of information:</p>
            <ul className="list-disc space-y-2 pl-6">
              <li>Contact details such as name, email address, and phone number</li>
              <li>Company information and project-related details</li>
              <li>Technical data including IP address, browser type, and device information</li>
              <li>Usage data related to how you interact with our website</li>
            </ul>
          </div>

          <div>
            <h2 className="mb-3 text-xl font-semibold text-gray-900 dark:text-gray-100">
              3. How We Use Your Information
            </h2>
            <ul className="list-disc space-y-2 pl-6">
              <li>To respond to inquiries and provide requested services</li>
              <li>To improve our products, services, and user experience</li>
              <li>To communicate updates, proposals, or important notices</li>
              <li>To maintain security and prevent misuse of our systems</li>
            </ul>
          </div>

          <div>
            <h2 className="mb-3 text-xl font-semibold text-gray-900 dark:text-gray-100">
              4. Data Sharing
            </h2>
            <p>
              We do not sell or rent your personal data. Information may only be shared with trusted
              partners or service providers when required to deliver our services, or when legally
              obligated to do so.
            </p>
          </div>

          <div>
            <h2 className="mb-3 text-xl font-semibold text-gray-900 dark:text-gray-100">
              5. Data Security
            </h2>
            <p>
              We implement industry-standard technical and organizational measures to safeguard your
              data. While no system is completely secure, we continuously improve our security
              practices to reduce risk.
            </p>
          </div>

          <div>
            <h2 className="mb-3 text-xl font-semibold text-gray-900 dark:text-gray-100">
              6. Cookies & Tracking
            </h2>
            <p>
              Our website may use cookies and similar technologies to analyze traffic and improve
              functionality. You can control cookie preferences through your browser settings.
            </p>
          </div>

          <div>
            <h2 className="mb-3 text-xl font-semibold text-gray-900 dark:text-gray-100">
              7. Your Rights
            </h2>
            <p>
              Depending on your location, you may have rights to access, correct, or request
              deletion of your personal data. Requests can be made by contacting us directly.
            </p>
          </div>

          <div>
            <h2 className="mb-3 text-xl font-semibold text-gray-900 dark:text-gray-100">
              8. Changes to This Policy
            </h2>
            <p>
              We may update this Privacy Policy from time to time. Any changes will be reflected on
              this page with an updated revision date.
            </p>
          </div>

          <div>
            <h2 className="mb-3 text-xl font-semibold text-gray-900 dark:text-gray-100">
              9. Contact Us
            </h2>
            <p>
              If you have questions or concerns about this Privacy Policy, please contact us at{' '}
              <a
                href="mailto:hello@akwidlabs.com"
                className="font-medium text-purple-500 hover:text-purple-400"
              >
                hello@akwidlabs.com
              </a>
              .
            </p>
          </div>
        </section>
      </div>
    </main>
  );
}
